import React from "react";
import styles from "./EtiquetaInvertir.module.css";
import { IconBoxArrowDiagonal } from "../Icons/Icons";

const Etiqueta = ({ hasInvestment = false }) => {
  return (
    <div className={styles.etiqueta}>
      <div className={styles.box}>
        <IconBoxArrowDiagonal colorIcon="#B9DE2C"/>
        <label className={styles.text}>{hasInvestment ? "Reinvertir" : "Invertir"}</label>
      </div>
    </div>
  );
};

export default Etiqueta;